import React, { Component } from 'react';
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import DataTable from "react-data-table-component";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

class PatientDashBoardTable extends Component {
  constructor(props) {
    super(props);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const today = new Date();
    this.state = {
      unifiedResults: {},
      isLoading: true,
      fromDate: props.fromDate ? new Date(props.fromDate) : (localStorage.getItem("startDate") ? new Date(localStorage.getItem("startDate")) : yesterday),
      toDate: props.toDate ? new Date(props.toDate) : (localStorage.getItem("endDate") ? new Date(localStorage.getItem("endDate")) : today),
      pageNum: null,
      paginationValue: 10,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.fetchUnifiedJournalData();
    }, 500);
    if (this.props.location.state != undefined) {
      this.setState({ pageNum: this.props.location.state.pageNum });
  }

  }
  componentDidUpdate(prevProps) {
    // Refetch data if the date changes
    if (prevProps.fromDate !== this.props.fromDate || prevProps.toDate !== this.props.toDate) {
      this.setState({
        unifiedResults: {},
        isLoading: true,
        fromDate: this.props.fromDate,
        toDate: this.props.toDate,

      }, () => {
        this.fetchUnifiedJournalData();
      });
    }

  }
  fetchUnifiedJournalData() {
    var thisController = this;

    $.ajax({
      url: "/my-jeeva-api/fetch-unified-journal-data",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        treatmentId: localStorage.getItem("treatmentIdForDashBoard"),
        patientAdmissionId: localStorage.getItem("patientAdmissionId"),
        startDate: thisController.state.fromDate,
        endDate: thisController.state.toDate
      },
      success: function (res) {
        if (res.success == true) {
          thisController.state.unifiedResults = res.result;
          thisController.setState(thisController.state);
          console.log("Unified results", thisController.state.unifiedResults);
        }
        thisController.state.isLoading = false;
        thisController.setState(thisController.state);
      },
    });
  }
  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no records to display</p>
    </div>
  );
  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }
  backToRiskBoard = () => {
    this.props.history.push({
      pathname: "/projectmgmt/reports"
    })
  }
  isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  render() {

    const { unifiedResults } = this.state;

    const customStyles = {
      cells: {
        style: {
          textAlign: 'center',
          verticalAlign: 'middle',
        },
      },
    };

    const allDates = Object.values(unifiedResults)
      .flatMap(obj => Object.keys(obj))
      .filter((value, index, self) => self.indexOf(value) === index)
      .sort((a, b) => new Date(a) - new Date(b));

    const columns = [
      { name: 'Entry Date', selector: 'date', sortable: true, width: '130px', center: true }
    ];

    Object.keys(unifiedResults).forEach(key => {
      columns.push({
        name: key,
        selector: key,
        sortable: true,
        // width: '250px',
        center: true,
        cell: row => <div style={{ textAlign: 'center' }}>{row[key] || 0}</div>
      });
    });

    const data = allDates.map(date => {
      const row = { date };
      Object.keys(unifiedResults).forEach(key => {
        row[key] = unifiedResults[key][date] || 0;
      });
      return row;
    });

    return (
      <div>
        <div style={{ display: "flex", justifyContent: "start" }}>


          <h4 style={{ marginLeft: "3px", marginTop: "6px" }}> {localStorage.getItem("patientName")}'s Journal Entries </h4>

        </div>
        <div className='card'>
        {this.state.isLoading && (
          <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
            <p>Loading ...</p>
          </div>
        )}
        {!this.state.isLoading && this.isEmpty(this.state.unifiedResults) && (
          <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
            <p>There are no records to display  </p>
          </div>
        )}
        {!this.isEmpty(this.state.unifiedResults) && (<div style={{boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)"  }}>
          <DataTable
            columns={columns}
            data={data}
            customStyles={customStyles}
            defaultPageSize={10}
            pageSizeOptions={[5, 10, 15]}
            pagination={this.state.paginationValue}
            onPageChange={this.onPageChange}
            page={this.state.pageNum}
            noDataComponent={<this.CustomNoDataComponent />}
          />
        </div>)}
        </div>
      </div>
    );
  }

}

export default PatientDashBoardTable;










// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PatientDashBoardTable.js